// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/workflow_template_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ApprovalMode } from "../../bfftypes/v1/approval_flow_type_pb";
import { file_bfftypes_v1_approval_flow_type } from "../../bfftypes/v1/approval_flow_type_pb";
import type { ApprovalFlowStage } from "./approval_flow_model_pb";
import { file_bffuser_v1_approval_flow_model } from "./approval_flow_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/workflow_template_model.proto.
 */
export const file_bffuser_v1_workflow_template_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_approval_flow_type, file_bffuser_v1_approval_flow_model, file_buf_validate_validate, file_google_protobuf_timestamp]);

/**
 * WorkflowCaseTag is a user-defined label + color pair (色付きタグ). Mirrors
 * internalapi.v1.WorkflowCaseTag. Shared by WorkflowCase.tags and
 * WorkflowTemplate.default_tags. Defined here (rather than
 * workflow_case_model.proto) because workflow_case_model.proto already
 * imports this file, avoiding an import cycle. color values are validated
 * against the domain's fixed 8-color palette in the backend, not here.
 *
 * @generated from message bffuser.v1.WorkflowCaseTag
 */
export type WorkflowCaseTag = Message<"bffuser.v1.WorkflowCaseTag"> & {
  /**
   * @generated from field: string label = 1;
   */
  label: string;

  /**
   * @generated from field: string color = 2;
   */
  color: string;
};

/**
 * Describes the message bffuser.v1.WorkflowCaseTag.
 * Use `create(WorkflowCaseTagSchema)` to create a new message.
 */
export const WorkflowCaseTagSchema: GenMessage<WorkflowCaseTag> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_template_model, 0);

/**
 * WorkflowTagPoolEntry mirrors internalapi.v1.WorkflowTagPoolEntry
 * (workflow-tag-delete-ui design, Decision B/F). See the backend message
 * godoc for field semantics.
 *
 * @generated from message bffuser.v1.WorkflowTagPoolEntry
 */
export type WorkflowTagPoolEntry = Message<"bffuser.v1.WorkflowTagPoolEntry"> & {
  /**
   * @generated from field: string label = 1;
   */
  label: string;

  /**
   * @generated from field: string color = 2;
   */
  color: string;

  /**
   * @generated from field: int32 reference_count = 3;
   */
  referenceCount: number;

  /**
   * @generated from field: bool deletable = 4;
   */
  deletable: boolean;
};

/**
 * Describes the message bffuser.v1.WorkflowTagPoolEntry.
 * Use `create(WorkflowTagPoolEntrySchema)` to create a new message.
 */
export const WorkflowTagPoolEntrySchema: GenMessage<WorkflowTagPoolEntry> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_template_model, 1);

/**
 * WorkflowTemplate is the root aggregate for a workflow template as exposed
 * to the BFF / frontend layer.
 *
 * @generated from message bffuser.v1.WorkflowTemplate
 */
export type WorkflowTemplate = Message<"bffuser.v1.WorkflowTemplate"> & {
  /**
   * id は Create RPC では client が知らない (= backend が UUID v7 で採番) ため空で送られる。
   * Update RPC では set されている必要があるが、 protovalidate の `ignore = IGNORE_IF_ZERO_VALUE` で
   * 「空文字 (= proto3 zero value) の場合は uuid validation を skip」 する。 set されている
   * ケースでは UUID 形式 check が走る。 nil UUID 拒否は backend handler / usecase で多層防御。
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * section は必須。
   *
   * @generated from field: bffuser.v1.WorkflowSection section = 5;
   */
  section: WorkflowSection;

  /**
   * is_built_in indicates that this template is managed by the SaaS
   * operator. Tenant users may edit (overlay) or delete built-in
   * templates; deletion is a soft-delete (the overlay is persisted and
   * supersedes the SaaS-provided default).
   *
   * @generated from field: bool is_built_in = 7;
   */
  isBuiltIn: boolean;

  /**
   * @generated from field: repeated bffuser.v1.BigStep big_steps = 8;
   */
  bigSteps: BigStep[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: optional string created_by = 11;
   */
  createdBy?: string;

  /**
   * @generated from field: optional string updated_by = 12;
   */
  updatedBy?: string;

  /**
   * default_tags are prefilled onto a case's tags when the case is created
   * from this template (spec workflow-templates.md AC-006). When empty, the
   * frontend falls back to the preset "定期"(blue)/"変更"(red) pair
   * (AC-TAG-002).
   *
   * @generated from field: repeated bffuser.v1.WorkflowCaseTag default_tags = 14;
   */
  defaultTags: WorkflowCaseTag[];

  /**
   * requires_bg_code is a backend-computed derived field (spec AC-003j,
   * workflow-bg-code-derivation design). Mirrors
   * internalapi.v1.WorkflowTemplate.requires_bg_code: true when at least one
   * sub-step links to a BG-requiring page (demand-forecast edit, procurement
   * plan, spot / intraday bidding — AC-WFW-003j). Read-only — the creation
   * dialog uses it to decide whether to show the BG code field and which
   * CreateWorkflowCasesRequest oneof member to send; it must never be sent
   * back in a Create / Update request.
   *
   * @generated from field: bool requires_bg_code = 15;
   */
  requiresBgCode: boolean;

  /**
   * display_order controls the global sort order of workflow templates within
   * an organization. 1-indexed; lower values appear first. Mirrors
   * internalapi.v1.WorkflowTemplate.display_order.
   *
   * @generated from field: optional int32 display_order = 16;
   */
  displayOrder?: number;

  /**
   * allows_generation_target_code is a backend-computed derived field (spec
   * AC-WFW-003j). Mirrors internalapi.v1.WorkflowTemplate.
   * allows_generation_target_code: true when the creation dialog may offer
   * 発電の計画提出者コード (ListWorkflowGenerationTargetCandidates) as BG code
   * candidates. Read-only.
   *
   * @generated from field: bool allows_generation_target_code = 17;
   */
  allowsGenerationTargetCode: boolean;
};

/**
 * Describes the message bffuser.v1.WorkflowTemplate.
 * Use `create(WorkflowTemplateSchema)` to create a new message.
 */
export const WorkflowTemplateSchema: GenMessage<WorkflowTemplate> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_template_model, 2);

/**
 * BigStep is a top-level step group within a WorkflowTemplate.
 * See internalapi.v1.BigStep for field semantics.
 *
 * @generated from message bffuser.v1.BigStep
 */
export type BigStep = Message<"bffuser.v1.BigStep"> & {
  /**
   * @generated from field: int32 display_order = 1;
   */
  displayOrder: number;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: repeated bffuser.v1.SubStep sub_steps = 6;
   */
  subSteps: SubStep[];
};

/**
 * Describes the message bffuser.v1.BigStep.
 * Use `create(BigStepSchema)` to create a new message.
 */
export const BigStepSchema: GenMessage<BigStep> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_template_model, 3);

/**
 * SubStep is a leaf-level task within a BigStep.
 * See internalapi.v1.SubStep for field semantics.
 *
 * @generated from message bffuser.v1.SubStep
 */
export type SubStep = Message<"bffuser.v1.SubStep"> & {
  /**
   * @generated from field: int32 display_order = 1;
   */
  displayOrder: number;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * linked_page_kind identifies the application page this sub-step links to.
   * UNSPECIFIED means no link is displayed. The frontend derives the URL and
   * label from this enum value via routePaths.
   *
   * @generated from field: optional bffuser.v1.LinkedPageKind linked_page_kind = 4;
   */
  linkedPageKind?: LinkedPageKind;

  /**
   * assignee_member_ids lists the eauth member_ids of the members (組織
   * メンバー) assigned to this sub-step (0..N, spec AC-WFT-010). Empty =
   * 担当者なし。「指定なし」 and real members are mutually exclusive in the
   * frontend UI only (spec AC-WFT-010d) — backend / DB do not distinguish
   * them; both are represented as an empty array.
   *
   * Field 6 was rewritten in-place from `optional string assignee_member_id`
   * to `repeated string assignee_member_ids` (issue #4550). This is a wire
   * breaking change (cardinality: optional -> repeated), but pre-release
   * + monorepo atomic deploy means no external v1 client exists to load
   * the old wire shape; producer and consumer rebuild from the same
   * commit. See docs/adr/workflow-substep-assignee-cardinality-array.md
   * for the DB-side rationale.
   *
   * @generated from field: repeated string assignee_member_ids = 6;
   */
  assigneeMemberIds: string[];

  /**
   * approval_setting mirrors internalapi.v1.SubStep.approval_setting. Absent
   * exactly when the linked page is スポット入札 / 時間前入札 (AC-WFT-010a).
   * On write (Create / Update), a non-bid sub-step sent without it is
   * rejected with INVALID_ARGUMENT and nothing is saved.
   *
   * @generated from field: optional bffuser.v1.SubStepApprovalSetting approval_setting = 7;
   */
  approvalSetting?: SubStepApprovalSetting;

  /**
   * Retained on a full template PUT even though this screen does not edit it.
   *
   * @generated from field: optional bffuser.v1.DemandAutoConfirmMethod demand_auto_confirm_method = 8;
   */
  demandAutoConfirmMethod?: DemandAutoConfirmMethod;

  /**
   * Retained on a full template PUT even though this screen does not edit it.
   *
   * @generated from field: optional int32 plan_auto_submit_offset_minutes = 9;
   */
  planAutoSubmitOffsetMinutes?: number;

  /**
   * Write-only intent marker mirroring internalapi.v1.SubStep. It is not
   * returned from reads.
   *
   * @generated from field: bool discard_incompatible_inherited_automation_fields = 10;
   */
  discardIncompatibleInheritedAutomationFields: boolean;

  /**
   * @generated from field: optional bffuser.v1.DemandAutoConfirmMethod demand_auto_confirm_other_method = 11;
   */
  demandAutoConfirmOtherMethod?: DemandAutoConfirmMethod;
};

/**
 * Describes the message bffuser.v1.SubStep.
 * Use `create(SubStepSchema)` to create a new message.
 */
export const SubStepSchema: GenMessage<SubStep> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_template_model, 4);

/**
 * SubStepApprovalSetting mirrors internalapi.v1.SubStepApprovalSetting (spec
 * workflow-templates.md AC-WFT-010e / 010f). stage_order of each stage is
 * ignored on receipt (position is authoritative) and returned as 1..N.
 *
 * @generated from message bffuser.v1.SubStepApprovalSetting
 */
export type SubStepApprovalSetting = Message<"bffuser.v1.SubStepApprovalSetting"> & {
  /**
   * @generated from field: bfftypes.v1.ApprovalMode mode = 1;
   */
  mode: ApprovalMode;

  /**
   * @generated from field: repeated bffuser.v1.ApprovalFlowStage stages = 2;
   */
  stages: ApprovalFlowStage[];
};

/**
 * Describes the message bffuser.v1.SubStepApprovalSetting.
 * Use `create(SubStepApprovalSettingSchema)` to create a new message.
 */
export const SubStepApprovalSettingSchema: GenMessage<SubStepApprovalSetting> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_template_model, 5);

/**
 * WorkflowSchedule classifies the workflow schedule type.
 * Renamed from WorkflowTemplateSchedule (context-free promotion so that both
 * workflow_template and workflow_case can share the enum without a
 * "Template" qualifier that only applies to the template side).
 * Mirrors internalapi.v1.WorkflowSchedule; kept context-local to
 * bffuser to allow independent evolution (promote to bfftypes/v1 when a
 * third consumer appears).
 *
 * @generated from enum bffuser.v1.WorkflowSchedule
 */
export enum WorkflowSchedule {
  /**
   * @generated from enum value: WORKFLOW_SCHEDULE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKFLOW_SCHEDULE_REGULAR = 1;
   */
  REGULAR = 1,

  /**
   * @generated from enum value: WORKFLOW_SCHEDULE_CHANGE = 2;
   */
  CHANGE = 2,
}

/**
 * Describes the enum bffuser.v1.WorkflowSchedule.
 */
export const WorkflowScheduleSchema: GenEnum<WorkflowSchedule> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_workflow_template_model, 0);

/**
 * WorkflowSection classifies the operational period the workflow covers
 * (単日 / 週間 / 月間 / 年間; legacy 当日 / 翌日 / 翌々日 remain readable).
 * Renamed from WorkflowTemplateSection for the same reason as WorkflowSchedule.
 * Mirrors internalapi.v1.WorkflowSection.
 *
 * @generated from enum bffuser.v1.WorkflowSection
 */
export enum WorkflowSection {
  /**
   * @generated from enum value: WORKFLOW_SECTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKFLOW_SECTION_TOMORROW = 1;
   */
  TOMORROW = 1,

  /**
   * @generated from enum value: WORKFLOW_SECTION_DAY_AFTER_TOMORROW = 2;
   */
  DAY_AFTER_TOMORROW = 2,

  /**
   * @generated from enum value: WORKFLOW_SECTION_WEEKLY = 3;
   */
  WEEKLY = 3,

  /**
   * @generated from enum value: WORKFLOW_SECTION_MONTHLY = 4;
   */
  MONTHLY = 4,

  /**
   * @generated from enum value: WORKFLOW_SECTION_ANNUAL = 5;
   */
  ANNUAL = 5,

  /**
   * 当日
   *
   * @generated from enum value: WORKFLOW_SECTION_TODAY = 6;
   */
  TODAY = 6,

  /**
   * 単日。新規の雛形・ケースはこの値を使い、旧 3 値は既存データの読取互換として残す。
   *
   * @generated from enum value: WORKFLOW_SECTION_SINGLE_DAY = 7;
   */
  SINGLE_DAY = 7,
}

/**
 * Describes the enum bffuser.v1.WorkflowSection.
 */
export const WorkflowSectionSchema: GenEnum<WorkflowSection> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_workflow_template_model, 1);

/**
 * DemandAutoConfirmMethod mirrors internalapi.v1.DemandAutoConfirmMethod.
 *
 * @generated from enum bffuser.v1.DemandAutoConfirmMethod
 */
export enum DemandAutoConfirmMethod {
  /**
   * @generated from enum value: DEMAND_AUTO_CONFIRM_METHOD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DEMAND_AUTO_CONFIRM_METHOD_PREV_DAY_COPY = 1;
   */
  PREV_DAY_COPY = 1,

  /**
   * @generated from enum value: DEMAND_AUTO_CONFIRM_METHOD_SAME_WEEKDAY_CATEGORY_PREV_WEEK_COPY = 2;
   */
  SAME_WEEKDAY_CATEGORY_PREV_WEEK_COPY = 2,

  /**
   * @generated from enum value: DEMAND_AUTO_CONFIRM_METHOD_WEIGHTED_MOVING_AVG = 3;
   */
  WEIGHTED_MOVING_AVG = 3,

  /**
   * @generated from enum value: DEMAND_AUTO_CONFIRM_METHOD_SAME_WEEKDAY_CATEGORY_WEIGHTED_AVG = 4;
   */
  SAME_WEEKDAY_CATEGORY_WEIGHTED_AVG = 4,

  /**
   * @generated from enum value: DEMAND_AUTO_CONFIRM_METHOD_SAME_WEEKDAY_PREV_WEEK_COPY = 5;
   */
  SAME_WEEKDAY_PREV_WEEK_COPY = 5,

  /**
   * @generated from enum value: DEMAND_AUTO_CONFIRM_METHOD_ACTUAL_TREND_CORRECTION = 6;
   */
  ACTUAL_TREND_CORRECTION = 6,

  /**
   * @generated from enum value: DEMAND_AUTO_CONFIRM_METHOD_EXTERNAL_JWA = 7;
   */
  EXTERNAL_JWA = 7,

  /**
   * @generated from enum value: DEMAND_AUTO_CONFIRM_METHOD_EXTERNAL_DEMAND_AI = 8;
   */
  EXTERNAL_DEMAND_AI = 8,

  /**
   * @generated from enum value: DEMAND_AUTO_CONFIRM_METHOD_EXTERNAL_METERLINK = 9;
   */
  EXTERNAL_METERLINK = 9,

  /**
   * @generated from enum value: DEMAND_AUTO_CONFIRM_METHOD_EXTERNAL_LOADNAVI = 10;
   */
  EXTERNAL_LOADNAVI = 10,

  /**
   * @generated from enum value: DEMAND_AUTO_CONFIRM_METHOD_EXTERNAL_ENSEMBLE_LAB = 11;
   */
  EXTERNAL_ENSEMBLE_LAB = 11,

  /**
   * @generated from enum value: DEMAND_AUTO_CONFIRM_METHOD_IN_HOUSE_ENGINE = 12;
   */
  IN_HOUSE_ENGINE = 12,

  /**
   * @generated from enum value: DEMAND_AUTO_CONFIRM_METHOD_WEEKLY_PREV_WEEK_COPY = 13;
   */
  WEEKLY_PREV_WEEK_COPY = 13,

  /**
   * @generated from enum value: DEMAND_AUTO_CONFIRM_METHOD_MONTHLY_PLAN_COPY = 14;
   */
  MONTHLY_PLAN_COPY = 14,

  /**
   * @generated from enum value: DEMAND_AUTO_CONFIRM_METHOD_CSV_REGISTERED_VALUES = 15;
   */
  CSV_REGISTERED_VALUES = 15,
}

/**
 * Describes the enum bffuser.v1.DemandAutoConfirmMethod.
 */
export const DemandAutoConfirmMethodSchema: GenEnum<DemandAutoConfirmMethod> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_workflow_template_model, 2);

/**
 * LinkedPageKind identifies the application page a sub-step links to.
 * UNSPECIFIED means the sub-step has no associated link (= link hidden).
 * Values map 1:1 to routePaths keys in the frontend.
 * Mirrors internalapi.v1.LinkedPageKind.
 *
 * @generated from enum bffuser.v1.LinkedPageKind
 */
export enum LinkedPageKind {
  /**
   * @generated from enum value: LINKED_PAGE_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_WORKFLOW_CASES = 1;
   */
  WORKFLOW_CASES = 1,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_DEMAND_ACTUAL_STATISTICS = 2;
   */
  DEMAND_ACTUAL_STATISTICS = 2,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_SUPPLY_GAP = 4;
   */
  SUPPLY_GAP = 4,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_SUPPLY_BILATERAL = 5;
   */
  SUPPLY_BILATERAL = 5,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_ADMIN_NOTIFICATION_CHANGE = 6;
   */
  ADMIN_NOTIFICATION_CHANGE = 6,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_SUPPLY_PLANT = 7;
   */
  SUPPLY_PLANT = 7,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_SUPPLY_48DATA = 8;
   */
  SUPPLY_48DATA = 8,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_ADMIN_INDIRECT_TRANSMISSION = 9;
   */
  ADMIN_INDIRECT_TRANSMISSION = 9,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_SUPPLY_RENEW_FORECAST = 10;
   */
  SUPPLY_RENEW_FORECAST = 10,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_ADMIN_FIP_PREMIUM = 11;
   */
  ADMIN_FIP_PREMIUM = 11,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_BIDDING_SPOT = 12;
   */
  BIDDING_SPOT = 12,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_BIDDING_INTRADAY = 13;
   */
  BIDDING_INTRADAY = 13,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_ADMIN_BID_LIMITS = 14;
   */
  ADMIN_BID_LIMITS = 14,

  /**
   * Deprecated: 選択肢からは除外済み。 過去 tenant overlay data 互換のため
   * enum 定義のみ残置する。 新規選択は LINKED_PAGE_KIND_SUBMISSION_MANAGEMENT を使う
   * (workflow-templates-linked-page-spec-compliance §4)。
   *
   * @generated from enum value: LINKED_PAGE_KIND_PLAN_SUBMISSION = 15;
   */
  PLAN_SUBMISSION = 15,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_PLAN_PROCUREMENT = 16;
   */
  PLAN_PROCUREMENT = 16,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_PLAN_GEN_SALES = 17;
   */
  PLAN_GEN_SALES = 17,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_PLAN_DEMAND_SUPPRESSION = 18;
   */
  PLAN_DEMAND_SUPPRESSION = 18,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_BALANCE_DEMAND = 19;
   */
  BALANCE_DEMAND = 19,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_BALANCE_GENERATION = 20;
   */
  BALANCE_GENERATION = 20,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_REVENUE_FORECAST = 21;
   */
  REVENUE_FORECAST = 21,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_REVENUE_INVOICE = 22;
   */
  REVENUE_INVOICE = 22,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_WEATHER_FORECAST = 23;
   */
  WEATHER_FORECAST = 23,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_DEMAND_FORECAST_DAILY = 24;
   */
  DEMAND_FORECAST_DAILY = 24,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_DASHBOARD = 25;
   */
  DASHBOARD = 25,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_CUSTOMER_CONTRACT = 26;
   */
  CUSTOMER_CONTRACT = 26,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_CUSTOMER_RATE = 27;
   */
  CUSTOMER_RATE = 27,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_CUSTOMER_SCHEDULE = 28;
   */
  CUSTOMER_SCHEDULE = 28,

  /**
   * 提出管理 (spec workflow-templates.md §機能詳細 4a / §サブステップ リンク先画面一覧)。
   * 「計画提出」 メインカテゴリのリンク先。 新規選択はこの kind を使い、
   * deprecated LINKED_PAGE_KIND_PLAN_SUBMISSION は overlay 互換のみに残す。
   *
   * @generated from enum value: LINKED_PAGE_KIND_SUBMISSION_MANAGEMENT = 29;
   */
  SUBMISSION_MANAGEMENT = 29,

  /**
   * 追加: workflow-template-linked-page-8categories (2026-08-03 PdM 判断)
   * spec §サブステップ リンク先画面一覧 (P0) の 8 カテゴリ拡張で不足していた kind。
   * 旧 LINKED_PAGE_KIND_WEATHER_FORECAST は overlay 互換のため定義を残置するが、
   * 新規選択は ADMIN_WEATHER_FORECAST_POINTS を使う。
   *
   * @generated from enum value: LINKED_PAGE_KIND_DEMAND_SINGULAR_DAY = 30;
   */
  DEMAND_SINGULAR_DAY = 30,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_BALANCE_IMPUTATION_POLICY = 31;
   */
  BALANCE_IMPUTATION_POLICY = 31,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_PLAN_SPLIT_SUPPLY = 32;
   */
  PLAN_SPLIT_SUPPLY = 32,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_ADMIN_UPLOADS = 33;
   */
  ADMIN_UPLOADS = 33,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_ADMIN_OCCTO = 34;
   */
  ADMIN_OCCTO = 34,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_ADMIN_ESLJ_ACCOUNTS = 35;
   */
  ADMIN_ESLJ_ACCOUNTS = 35,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_ADMIN_WEATHER_FORECAST_POINTS = 36;
   */
  ADMIN_WEATHER_FORECAST_POINTS = 36,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_CUSTOMER_DEMAND_GROUPS = 37;
   */
  CUSTOMER_DEMAND_GROUPS = 37,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_ADMIN_APPROVAL_FLOW = 38;
   */
  ADMIN_APPROVAL_FLOW = 38,

  /**
   * 発電所別 (同時同量) 画面。
   *
   * @generated from enum value: LINKED_PAGE_KIND_BALANCE_GENERATION_DETAIL = 39;
   */
  BALANCE_GENERATION_DETAIL = 39,
}

/**
 * Describes the enum bffuser.v1.LinkedPageKind.
 */
export const LinkedPageKindSchema: GenEnum<LinkedPageKind> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_workflow_template_model, 3);

